import { render, staticRenderFns } from "./GestionarCapacitacion.vue?vue&type=template&id=0ec0462f&scoped=true"
import script from "./GestionarCapacitacion.vue?vue&type=script&lang=js"
export * from "./GestionarCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./GestionarCapacitacion.vue?vue&type=style&index=0&id=0ec0462f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0462f",
  null
  
)

export default component.exports